import React, { useEffect, useRef } from 'react';

/**
 * Bottom-right CLI-style annotate / log console.
 * Blueprint: docs/SIM_LAB_ANNOTATE.md
 */
export default function LabAnnotateConsole({
  open = false,
  kind = 'faucet-hit',
  stationId = 'sink-vanity',
  pinCount = 0,
  logs = [],
  walkMode = false,
  source = 'local',
  authEmail = null,
}) {
  const scrollerRef = useRef(null);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [logs]);

  if (!open) return null;

  const who = authEmail ? authEmail.split('@')[0] : 'anon';

  return (
    <aside
      className="lab-ann-console"
      aria-label="Annotate console"
      role="log"
    >
      <div className="lab-ann-console-head">
        <span className="lab-ann-console-title">annotate</span>
        <span className="lab-ann-console-meta">
          {pinCount} pin{pinCount === 1 ? '' : 's'} · {source}
          {walkMode ? ' · walk' : ''}
        </span>
      </div>
      <div className="lab-ann-console-line">
        <span className="lab-ann-console-prompt">›</span>
        <span>
          {kind}
          <span className="lab-ann-console-dim"> @ </span>
          {stationId}
          <span className="lab-ann-console-dim"> · </span>
          {who}
        </span>
      </div>
      <div className="lab-ann-console-logs" ref={scrollerRef}>
        {logs.length === 0 ? (
          <div className="lab-ann-console-dim">
            click scene to pin · notes in panel · n exit
          </div>
        ) : (
          logs.map((line, i) => (
            <div key={`${line.t}-${i}`} className="lab-ann-console-log">
              <span className="lab-ann-console-dim">{line.t}</span> {line.msg}
            </div>
          ))
        )}
      </div>
      <div className="lab-ann-console-foot">
        click pin · notes in panel · n toggle · esc exit
      </div>
    </aside>
  );
}
